module.exports = __webpack_public_path__ + "img/level_one.6a7347ff.png";